import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingController, ModalController, Platform, ToastController } from '@ionic/angular';
import { login_signup } from 'src/app/interfaces/login_signup';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {

  slideOpts = {
    initialSlide: 1,
    speed: 400,
    autoplay:{
      delay:2000
    }
  };  

  showNavBar:boolean = false;

  userForm : FormGroup;
  userInfo = {} as login_signup;

  constructor(
    private loginService:LoginService, 
    private router: Router, 
    private toastController: ToastController,
    private platform: Platform, 
    private modalController: ModalController, 
    private formBuilder: FormBuilder, 
    private loadingController: LoadingController,
    private menuController: ModalController) {

    var deviceWidth = platform.width();
    
    this.showNavBar = deviceWidth < 500 ? true : false;

    this.userForm = this.formBuilder.group({
      email: ['',[Validators.email, Validators.required]],
      password: ['',[Validators.required, Validators.minLength(5)]]
    })

   }

  ngOnInit() {}

  async loginWithGoogle(){
    await this.loginService.loginWithGoogle().then(data => {

      if(data.isNew){
        this.closeModalAndMenu();
        this.router.navigateByUrl('/crear-perfil');
      }else{
        this.closeModal();
        this.router.navigateByUrl('/home');
      }
    });
  }

  closeModalAndMenu(){
    this.closeModal();
    this.menuController.dismiss('mobilelandin');
  }

  async loginWithFacebook(){
     await this.loginService.loginWithFacebook();
  }

  closeModal(){
    this.modalController.dismiss();
  }

  goToSignUp(){
    this.router.navigateByUrl('signup')
  }

  login(){
    this.presentLoading();
    const userData= this.userInfo = this.userForm.value as login_signup;
    this.loginService.loginWithEmailPaswword(userData).then(res => {
      var text = `Bienvenido ${res["displayName"]}`
      this.router.navigateByUrl('/home');
      this.presentToast(text,"success")
      this.loadingController.dismiss();

    },err => {
      this.presentToast(err,"danger")
      this.loadingController.dismiss();
    }).catch(err=> {
      this.presentToast(err,"danger")
      this.loadingController.dismiss();
    })

    setTimeout(() => {
      this.loadingController.dismiss('');
    }, 2000);

  }

  async presentLoading() {
    const loading = await this.loadingController.create({
      message: 'Cargando...',
      spinner: 'bubbles'
    });
    await loading.present();
  }

  async presentToast(text, _color) {
    const toast = await this.toastController.create({
      message: text,
      duration: 3000,
      color:_color
    });
    toast.present();
  }
}